import React from 'react';
import './styles/main.scss';
import 'semantic-ui-css/semantic.min.css';
import Home from './pages/home'

function App() {
  return (
    <div className="App">
      <Home />
    </div>
  );
}

export default App;
